module.exports = __webpack_public_path__ + "static/media/sol_lewitt_391_color.a9fcb9bc.svg";